import api from './api';

const NetworkService = {
  states: () => api.get('states'),
  cities: stateId => api.get(`states/${stateId}/cities`),
  cepInfo: cep => api.get('addresses/cep-info', { params: { cep } })
};

export default NetworkService;
